module.exports = __webpack_public_path__ + "img/symbol_7.412aa150.png";